import {useSelector} from 'react-redux'
import prop from 'ramda/src/prop'
import pipe from 'ramda/src/pipe'
import {ROOT} from '../routes'
import ifElse from 'ramda/src/ifElse'
import {always, equals} from 'ramda'
import Create from './Create'
import Play from './Play'
import React from 'react'

function CurrentPage() {
  const locationType = useSelector(selectLocationType)
  return React.createElement(getPageForLocationType(locationType))
}

const selectLocationType = pipe(prop('location'), prop('type'))

const getPageForLocationType = ifElse(
  equals(ROOT),
  always(Create),
  always(Play)
)

export default CurrentPage